
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"constitution"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_sector"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"line_of_activity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"group_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"segment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processing_location"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":200}};
    doc.loc.source = {"body":"fragment CustomerDetails on Customer {\n  id\n  status\n  stage\n  name\n  constitution\n  sector\n  sub_sector\n  line_of_activity\n  landline\n  email\n  website\n  group_name\n  segment\n  processing_location\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/CustomerFragment.graphql
// module id = 172
// module chunks = 0